require('./aggregatorTableDetails.scss');

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { OKTable } from 'commonsComponents/OKTable';
import { OKTableRow } from 'commonsComponents/OKTableRow';
import { OKTableCell } from 'commonsComponents/OKTableCell';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import { LabelDate } from 'commonsComponents/labelDate';
import { OKLink } from 'commonsComponents/OKLink';
import { LoadingSection } from 'commonsComponents/loadingSection';

import CategoryTableCell from 'components/commons/categoryTableCell/categoryTableCell';
import { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } from 'constants/commonsComponents';

import { formatAmountObject, getPlainAmountObject, formatAmount } from 'utilities/currencyHelper';
const { getLanguage } = require('core/i18n').i18n;
const { AGGREGATOR_NEW_FEATURES } = require('constants/flagBasedFeatures');

class AggregatorTableDetails extends React.Component {
    constructor(props) {
        super(props);
    }

    renderDate = ({ value }) => {
        return (
            value && <LabelDate
                date={value}
                language={getLanguage()}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />
        );
    };

    renderCategory = ({ value }) => {
        const { immFlagBasedFeatures } = this.props;

        const AGGREGATOR_V2 = immFlagBasedFeatures.get(AGGREGATOR_NEW_FEATURES);
        const iconCategory = AGGREGATOR_V2 ? value.icon : null;

        return value.category && value.subcategory && <CategoryTableCell newCategorized={AGGREGATOR_V2} iconCategory={iconCategory} category={value.category} subcategory={value.subcategory}/>
    };

    renderLink = ({value, to}) => {
        return value && to && (
            <OKLink to={to}>
                {value}
            </OKLink>
        );
    };

    renderText = ({value}) => {
        return value;
    };

    renderAmount = ({value}) => {
        const amount = value && getPlainAmountObject(value);
        return (
            value &&
            <OneLineSymbolAmount
                amountObject={amount}
                language={getLanguage()}
                amountObjectFormatted={formatAmountObject(amount, true)}
            />
        );
    };

    renderNumber = ({value}) => {
        return value && !Number.isNaN(Number(value)) ? formatAmount(value, getLanguage(), 2, false) : 0;
    };

    renderValue = (item) => {
        const type = item.type;
        const typeMap = {
            date: this.renderDate,
            category: this.renderCategory,
            text: this.renderText,
            amount: this.renderAmount,
            link: this.renderLink,
            number: this.renderNumber,
            custom: (itm) => itm.value
        };

        return typeMap[type](item);
    };

    renderRow = (cell, index) => {
        const { investmentTable } = this.props;

        const cellClassName = classNames("aggregator-table-details__cell", {
            "aggregator-table-details__cell--right": cell.right,
            "aggregator-table-details__cell--bold": cell.bold,
            "aggregator-table-details-investment__cell": investmentTable
        });

        return (
            <OKTableCell key={'cellData-' + index} className={cellClassName}>
                {this.renderValue(cell)}
            </OKTableCell>
        );
    };

    renderBody = () => {
        const { values, investmentTable } = this.props;

         const className = classNames("ok-table-row", {
           "ok-table-row-investment": investmentTable
        });

        return values.map((row, index) => (
            <OKTableRow className={className} key={'rowData-' + index}>
                {row.map(this.renderRow)}
            </OKTableRow>
        ));
    };

    renderHeader = () => {
        const { header, investmentTable } = this.props;
        const className = classNames("aggregator-table-details__cell-header", {
           "aggregator-table-details-investment__cell-header": investmentTable
        });

        return (
            <OKTableRow asHeader={true}>
                {header.map((h, i) => (
                    <OKTableCell
                        asHeader={true}
                        key={`thLabel-${i}`}
                        className={className}
                    >
                        {h}
                    </OKTableCell>
                ))}
            </OKTableRow>
        );
    };

    render() {
        const { loading, toButton, textButton, investmentTable } = this.props;
        const header = this.renderHeader();
        const body = this.renderBody();

        const className = classNames("aggregator-table-details", {
           "aggregator-table-details-investment": investmentTable
        });

        if (loading)
            return <LoadingSection />;

        return (
            <div className={className}>
                <OKTable>
                    <thead>{header}</thead>
                    <tbody>{body}</tbody>
                </OKTable>
                {toButton && textButton && (
                    <div className="aggregator-table-details__buttons">
                        <OKLink modifier="widget" to={toButton}>
                            {textButton}
                        </OKLink>
                    </div>
                )}
            </div>
        );
    }
}

AggregatorTableDetails.propTypes = {
    loading: PropTypes.bool,
    header: PropTypes.array,
    values: PropTypes.array,
    toButton: PropTypes.func,
    textButton: PropTypes.element,
    investmentTable: PropTypes.bool,
    immFlagBasedFeatures: PropTypes.object
};

module.exports.constructor = AggregatorTableDetails;

module.exports.AggregatorTableDetails = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
    })
)(AggregatorTableDetails);
